import { useContext, useEffect } from "react";
import useCustomSnackbar from "@/snackbars/useCustomSnackbar";
import {
	App2NotificationContext,
	App2NotificationSeverity,
} from "./App2NotificationContext";

/**
 * App2-only snackbar manager. Subscribes to App2NotificationContext and shows
 * notistack toasts. Use only inside the App2 tree (inside App2NotificationProvider).
 */
export const useApp2SnackbarManager = () => {
	const {
		successSnackbar,
		errorSnackbar,
		warningSnackbar,
		processInProgressSnackbar,
		infoSnackbar,
	} = useCustomSnackbar();
	const { notification } = useContext(App2NotificationContext);

	useEffect(() => {
		if (!notification) return;
		const { body, title, lifeTime, severity } = notification;
		const multiple = notification.multiple ?? false;
		const message = body ? body : title;

		switch (severity) {
			case App2NotificationSeverity.success:
				successSnackbar(message, !multiple, lifeTime ?? undefined);
				break;
			case App2NotificationSeverity.error:
				errorSnackbar(message, !multiple, lifeTime ?? undefined);
				break;
			case App2NotificationSeverity.warning:
				warningSnackbar(message, !multiple, lifeTime ?? undefined);
				break;
			case App2NotificationSeverity.processInProgress:
				processInProgressSnackbar(message, !multiple);
				break;
			case App2NotificationSeverity.neutral:
				infoSnackbar(message, !multiple, lifeTime ?? undefined);
				break;
			default:
				break;
		}
	}, [notification]);
};
